e360.controller('EditInviteeController',
   ['$scope', '$window', 'inviteesApi', 'eventsApi', '$stateParams', 'utils', 'session', 'toast', 'loader', 'titleService', 'GuestTypeService',
      function($scope, $window, inviteesApi, eventsApi, $stateParams, utils, session, toast, loader, titleService, guestTypeService) {
         var members = {};

         titleService.setTitle('Invitee Management');
         $scope.loader = loader;
         $scope.invitee = { country: 'US' };

         $scope.onPickPlace = function(place) {
            $scope.invitee.city = place.city;
            $scope.invitee.state = place.stateCode;
            $scope.invitee.country = place.countryCode;
         };

         members.initialize = function () {
            loader.hide();
            $scope.isInitializing = true;
            $scope.isEditMode = ($stateParams.id) ? true : false;

            guestTypeService.list(session.getCampaign().id).then(function(guestTypes) {
               $scope.guestTypes = guestTypes;
            });

            if ($scope.isEditMode) {
               members.getInvitee($stateParams.id);
            } else if ($stateParams.eventId) {
               members.getEvent($stateParams.eventId);
            } else {
               $scope.isInitializing = false;
            }
         };

         members.getInvitee = function (id) {
            inviteesApi.get(id).then(function (data) {
               $scope.invitee = data;
               if (data.dateOfBirth) {
                  $scope.invitee.dateOfBirth = moment(data.dateOfBirth).format('MM/DD/YYYY');
               }

               members.getEvent(data.eventId);
            });
         };

         members.getEvent = function (eventId, guestTypeId) {
            if (eventId) {
               eventsApi.get(eventId).then(function(event) {
                  $scope.invitee.event = event;
               }).finally(function() {
                  $scope.isInitializing = false;
               });
            } else {
               $scope.isInitializing = false;
            }
         };

         $scope.goBack = function () {
            $window.history.back();
         };

         $scope.save = function () {
            var invalidPhone = $('input.ng-invalid-international-phone-number');
            if (invalidPhone && invalidPhone.length > 0) {
               toast.error().message('Please enter a valid phone number').send();
               return;
            }

            $scope.$broadcast('phone.save.pre', true);

            var dto = angular.copy($scope.invitee);

            if (dto.event) {
               dto.eventId = dto.event.id;
            } else {
               dto.eventId = null;
            }

            if (dto.dateOfBirth) {
               dto.dateOfBirth = utils.toServerDateTime(dto.dateOfBirth, "MM/DD/YYYY");
            }

            if (!dto.email) {
               dto.email = null;
            }

            dto.campaignId = session.getCampaign().id;

            var promise, message;

            loader.showSpinner();
            if ($scope.isEditMode) {
               message = 'Invitee saved!';
               promise = inviteesApi.update(dto);
            } else {
               message = 'Invitee created!';
               promise = inviteesApi.create(dto);
            }

            promise.then(function () {
               $scope.goBack();
               toast.success()
                  .message(message)
                  .send();
            })['finally'](function () {
               loader.hide();
               $scope.$broadcast('phone.save.post', true);
            });
         };

         members.initialize();

      }]);
